import { Component, OnInit } from '@angular/core';
import {
	Data, Subscription, DataLoaderService, ResetService, CommonDataService,
	PriceCalculationService, AlternateOptionsService, ProgressBarService,
	SummaryService, SortingService

} from '../service-call-index';
import { ExpertValidation } from '../../expert-screen-components/expert-validation/expert-validation.component'
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
@Component({
	selector: 'local-options',
	templateUrl: './local-options.template.html',
	styleUrls: ['./local-options.component.css'],
})
export class LocalOptions implements OnInit {
	public localOptions: Data[];
	public lengthOfLocalOptions: number;
	public selectedLocalOptions: Data[] = [];
	public flag: boolean = false;
	public toggleContViewLocal: boolean = false;
	public localOptionsSuggList = [];
	public currency: string;
	private subscription: Subscription;
	public errMessage;
	public icon: string = "gray";
	public vehicleInfo: any;
	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService,
		private resetService: ResetService, private alternateOptionsService: AlternateOptionsService,
		private progressService: ProgressBarService, private priceCalculationService: PriceCalculationService, private expertValidation: ExpertValidation, private sortingService: SortingService,
		private summaryValidationComponent: SummaryValidationComponent,private alternateScreenComponent: AlternateScreenComponent,
		private summaryService: SummaryService, private vehicleInfoService: VehicleInfoService) {
		this.vehicleInfo = this.vehicleInfoService.extractData();
		this.currency = this.dataLoaderService.data.currencyType;
		this.localOptions = this.dataLoaderService.data.options;
	}
	/**
	 * Local Options are loaded on initialisation
	 * @param none
	 * @returns none
	 */
	ngOnInit() {
		this.summaryService.getSelectedOptions();

		if (this.commonDataService.localFlag) {
			this.toggleContViewLocal = true;
		}

		// retention service
		this.subscription = this.priceCalculationService.notifyObservableExpertComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertLocal") {
				this.selectedLocalOptions = [];
				for (let i in selectedOption.data[0]) {
					for (let j in this.localOptions) {
						if (this.localOptions[j].code === selectedOption.data[0][i].code) {
							// this.localOptions[j].selected = true;
							this.selectedLocalOptions.unshift(selectedOption.data[0][i]);
						}
					}
				}
			}
		});

		//fetching length for displaying in HTML
		this.lengthOfLocalOptions = this.dataLoaderService.data.options.length;

		//on load
		this.localOptions.forEach(element => {
			if (element.selected === true) {
				this.selectedLocalOptions.unshift(element);
				this.priceCalculationService.normalModePriceCalculation();
			}
		});
	}
	/**
	 * To select a local option and populating the selected option in an array 
	 * @param item of Data type
	 * @returns none
	 */
	selectLocalOption(item) {

		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);

		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetLocalOptionsFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.localOptionsSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.localOptionsSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						for (let i in this.localOptions) {
							if (this.localOptions[i].code === item.code) {
								this.localOptions[i].selected = true;
								//Updated prices from validation response
					            this.alternateScreenComponent.updatedPrices();
								
							}
						}
						this.flag = this.itemCheck(item);
						if (this.flag) {
							// this.dataLoaderService.flagDictionary.validated = false;
							this.selectedLocalOptions.unshift(item);
						}
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						if(this.dataLoaderService.flagDictionary.alternateValidateFlag === false){
							this.commonDataService.progressBarColorFlag = true;
							if(this.commonDataService.progressBarColorFlag == true){
								setTimeout(() => {
								this.progressService.illuminateGreen();							
								}, 0);
							}
						}
						else{
							if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
								setTimeout(() => {
									this.progressService.illuminateGreen();
								}, 0);
							}
					    }
						this.saveLocal();
						}
						this.sortingService.sortCodes(this.localOptions, true)
						
						
				}, err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.localOptions) {
				if (this.localOptions[i].code === item.code) {
					this.localOptions[i].selected = true;
				}
			}
			this.flag = this.itemCheck(item);
			if (this.flag) {
				this.dataLoaderService.flagDictionary.validated = false;
				this.selectedLocalOptions.unshift(item);
			}
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.localOptions, true)
			this.saveLocal();
			
		}
		this.progressService.progressBarValidation();
	}
	/**
	 * To uncheck the local option selected and splice it from the array 
	 * @param item of Data type
	 * @returns boolean value
	 */
	itemCheck(item): boolean {
		let index: number = -1;
		for (let j in this.localOptions) {
			for (let i in this.selectedLocalOptions) {
				if ((item.code === this.selectedLocalOptions[i].code) && (item.code === this.localOptions[j].code)) {
					this.localOptions[j].selected = false;
					//Updated prices from validation response
					
					for (let s in this.dataLoaderService.gccUpdatedPrices) {
						for(let k in this.localOptions){
							if (this.localOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.localOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
								this.localOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
						}
					}
				}
				this.flag = false;
				this.selectedLocalOptions.splice(Number(i), 1)
				return this.flag;
			}
		}
			this.flag = true;
		}
		return this.flag;
	}

	/**
	 * To go to the next Tab: Package Options tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		this.dataLoaderService.flagDictionary.modeFlag = 'normal';
		this.commonDataService.notifyOther({ option: 'activePackage' });
	}
	/**
	 * To send the selected local option to the Summary screen and calculate the price accordingly
	 * @param none
	 * @returns none
	 */
	saveLocal() {

		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.selectedLocalOptions] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.selectedLocalOptions] });

		this.priceCalculationService.normalModePriceCalculation();



	}

	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();
	}

	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
	}

	checkForEGPkgOptions(){
		if(this.isMarketEG()){
			if((this.dataLoaderService.data.localPackagesList.length>0)&&(this.dataLoaderService.data.packages.length>0)){
				return false;
			}
			else{
				return true;
			}
		}
	}	

	isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
	}

	isMarketEG(){
		return Utils.isCountryEG(this.vehicleInfo.orderingMarket);
	}

}




// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/local-options/local-options.component.ts